export default __webpack_public_path__ + "images/64_2_image.jpg";